import React from 'react';
import {Font, Page, View, Document, StyleSheet} from '@react-pdf/renderer/dist/react-pdf.es';
import Header from "./Partials/Header";
import Address from "./Partials/Address";
import Meta from "./Partials/Meta";
import Body from "./Partials/Body";
import Footer from "./Partials/Footer";

// Create styles
const styles = StyleSheet.create({
    page: {
        paddingLeft:'20mm',
        paddingTop:'15mm',
        paddingBottom: 80,
        backgroundColor: '#ffffff'
    },
    foldingMark:{
        height:'105mm',
        width:10,
        borderTop:0.5,
        borderBottom:0.5,
        position:'absolute',
        top:'105mm',
        left:0,
    },
    punchMark: {
        height:1,
        borderTop:0.5,
        position:'absolute',
        left:'10',
        top: '148.5mm',
        width:15,
    }
});

Font.register( {
    family: 'Lato',
    src: `/fonts/Lato-Regular.ttf`,
});
Font.register( {
    family: 'Lato Italic',
    src: `/fonts/Lato-Italic.ttf`,
});
Font.register( {
    family: 'Lato Bold',
    src: `/fonts/Lato-Bold.ttf`,
});
Font.register( {
    family: 'Crimson',
    src: `/fonts/CrimsonPro-Regular.ttf`,
});
Font.register( {
    family: 'Crimson Italic',
    src: `/fonts/CrimsonPro-Italic.ttf`,
});
Font.register( {
    family: 'Crimson Bold',
    src: `/fonts/CrimsonPro-Bold.ttf`,
});

// Create Document Component
const PDFDocument = ({...props}) => {
    const {values} = props;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.foldingMark} />
                <View style={styles.punchMark} />
                <Header />
                <Address contact={values.contact} />
                <Meta values={values} />
                <Body  values={values} />
                <Footer />
           </Page>
        </Document>
    )
}

export default PDFDocument;
